/* moved to item.js */
var vms = vms || {};
vms.cpc = vms.cpc || {};
/* created on: 2015_11_23 by: Davor
*  updated on: ...
*/
vms.cpc.par = {
    valForm: function (pIps, pIpv, pTsk, pPid, pThis) {
        $(".vsm-parValForm").remove();
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=itemParValForm",
                x01: pIps,
                x02: pIpv,
                x03: pTsk,
                x04: pPid
            },
            success: function (d) {
                $(d).dialog({
                    modal: true,
                    resizable: false,
                    width: 410
                });
                $date = $("input.vsmDateItem");
                $date.datetimepicker({ dateFormat: unescape($date.attr("data-format")), timeFormat: unescape($date.attr("data-time-format")) });
            }
        });
    },
    /* created on: 2015_11_16 by: Davor
    *  updated on: ...
    */
    valSubmit: function (pThis, pSignOff) {
        /*var vConfirm;
        if ($v("P_IPV_ID") > 0) vConfirm = confirm('This parameter has been sumbitted, are you sure you want to override previous value?');
        else vConfirm = confirm('Are you sure you want to submit this value?');
        if (vConfirm) {*/
        var v05;
        if (pSignOff) v05 = pSignOff;
        else v05 = '';
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=itemParValSubmit",
                x01: $v("P_VALUE"),
                x02: $v("P_IPV_ID"),
                x03: $v("P_IPS_ID"),
                x04: $v("P_TSK_ID"),
                x05: v05,
                x06: $v("P_DATE")
            },
            success: function (d) {
                if (d.trim() == 'CL') alert('Entered value is smaller then previous Value, please review your entry!')
                else {
                    $(".vsm-parValForm").dialog("close");
                    if ($v("pFlowStepId") == 470) refresh_ir_report();
                    else if ($v("pFlowStepId") == 369) apex.region("pgIR5").refresh();
                    else if ($("#lx-task-list").length) {
                        if (pSignOff) $(pThis).closest(".t_task").remove();
                        else lxTaskList($v("taskListProjectId"));
                    } else if ($v("pFlowStepId") == 1) {
                        if (pSignOff) $("#close_tsk_" + $v("P_TSK_ID")).closest(".vh_activity").remove();
                        else location.reload();
                    } else {
                        apex.region("ir1").refresh();
                    }
                }
            }
        });
        //}
    }
};

var itemParValForm = vms.cpc.par.valForm;
var itemParValSubmit = vms.cpc.par.valSubmit;